import { apiClient } from "@/services/api";

export default {
  complete(data) {
    return apiClient.post("/survey", data);
  },
  getResponse() {
    return apiClient.get("/user/survey");
  }
};
